/* eslint-disable @typescript-eslint/no-explicit-any */
import { MonoTypeOperatorFunction, Observable } from "rxjs"
import { pluck, withLatestFrom } from "rxjs/operators"

// Like RxJS `sample`, but does not drop events if the sampled Observable has not changed
export function sample<T>(sampler$: Observable<any>): MonoTypeOperatorFunction<T> {
  return samplee$ => sampler$.pipe(
    withLatestFrom(samplee$),
    pluck(1),
  )
}
